import { useChatbotScreen } from "../hooks/useChatbotScreen";
import { ChatbotScreenBase } from "../components/ChatbotScreenBase";

function HiBro() {
    const props = useChatbotScreen("hi_bro");
    return <ChatbotScreenBase {...props} />;
}

export default HiBro;
